import { useState, useEffect } from 'react';
import CompanyService from 'services/company2';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
/**
 * 采购说明搜索组件
 */
function ExtendFields(props) {
  const [extendObj, setExtendObj] = useState({
    fieldName: '',
    fieldValue: ''
  });

  const [extendFields, setExtendFields] = useState([]);

  const { orgCompanyCode, onComplete, isPurchase, extendSearchParams } = props;

  //初始化
  useEffect(() => {
    if (!orgCompanyCode) {
      return;
    }
    function getDynaFields() {
      CompanyService.getExtendFields(
        orgCompanyCode,
        false,
        '',
        isPurchase
      ).then(rs => {
        let arr = [];
        for (let key in rs) {
          if (Object.prototype.hasOwnProperty.call(rs, key)) {
            arr.push({
              id: key,
              text: rs[key]
            });
          }
        }
        if (arr.length > 0) {
          setExtendFields(arr);
          // 恢复记忆数据
          if (extendSearchParams?.length === 1) {
            setExtendObj(extendSearchParams[0]);
          }
        }
      });
    }
    getDynaFields();
  }, [orgCompanyCode, isPurchase, extendSearchParams]);

  //扩展字段改变
  function handleExtendFieldsChange(event) {
    let fieldName = event.target.value;
    let copy = Object.assign({}, extendObj);
    let found = extendFields.find(item => item.id === fieldName);
    if (found) {
      copy.fieldName = found.id;
    } else {
      copy.fieldName = '';
    }

    setExtendObj(copy);
  }

  function handleChange(event) {
    let fieldValue = event.target.value;
    let copy = Object.assign({}, extendObj);
    copy.fieldValue = fieldValue;
    setExtendObj(copy);
  }

  return (
    <div>
      {/* 采购说明 */}
      {extendFields.length > 0 && (
        <div
          style={{
            marginTop: '5px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'flex-end'
          }}
        >
          <FormControl
            style={{
              marginRight: '20px',
              marginTop: '3px',
              marginLeft: '10px'
            }}
          >
            <InputLabel htmlFor="extend-field">请选择</InputLabel>
            <Select
              style={{ minWidth: '100px', fontSize: '14px' }}
              value={extendObj.fieldName}
              onChange={handleExtendFieldsChange}
              input={<Input id="extend-field" />}
            >
              {extendFields.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  <ListItemText primary={item.text} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            style={{ verticalAlign: 'bottom' }}
            id="input-with-icon-textfield"
            label="请输入产品关键属性"
            value={extendObj.fieldValue}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={() => {
                    onComplete(extendObj);
                  }}
                >
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            variant="standard"
          />
        </div>
      )}
    </div>
  );
}

export default ExtendFields;
